import useReactHookForm from "hooks/useReactHookForm";
import { useAppDispatch} from "hooks/redux";
import { Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import liveClassClientService from "utils/graphql/liveclassClient";
import { CREATE_NLEARN3_LIVECLASS_PACKAGES} from "utils/graphql/services/live-classes/mutations";
import { nl3LiveclassPackageInitialValues, nl3LiveclassPackageMandatoryFields, nl3LiveclassPackageProperties, nl3LiveclassPackageValidationSchema } from "./helper";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";


export const CreateNl3LiveclassPackage = () => {

  const dispatch = useAppDispatch();
  const history = useHistory();

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    nl3LiveclassPackageInitialValues,
    nl3LiveclassPackageValidationSchema,
    nl3LiveclassPackageMandatoryFields
  );

  const [CreateNl3LiveclassPackageList, { loading, error, data }] = useMutation(
    CREATE_NLEARN3_LIVECLASS_PACKAGES,
    {
      client: liveClassClientService,
    }
  )

  const handleCreateNl3LiveclassPackage = async () => {
    try {
      const response: any = await CreateNl3LiveclassPackageList({
        variables: {
          input: {
            academicYearId: watch()?.academicYearId,
            collegeId: watch()?.collegeId,
            classId: watch()?.classId,
            streamId: watch()?.streamId,
            batchId: watch()?.batchId,
            sectionId: watch()?.sectionId,
          },
        },
      });
      
      if (!isEmpty(response?.data?.createNlearn3LiveclassPackages?.package?.id)) {
        dispatch(
          snackbarRequest({
            message:`Created Nl3 Liveclass Package successfully`,
          })
        );
        history.replace(`/live-classes/nlearn3-liveclass-packages`);
      } else {
        dispatch(
          snackbarRequest({
            message:`failed to create Nl3 Liveclass Package`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message: `${err?.message}` || `failed to create Nl3 Liveclass Package`,
          type: "error",
        })
      );
    }
  };

  return (
    <div>
      <TypographyHeading>Create Nlearn3 Liveclass Package</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={nl3LiveclassPackageProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />

          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateNl3LiveclassPackage}
              loading={loading}
              disabled={!isFieldsValidate(errors, nl3LiveclassPackageMandatoryFields, getValues)}
              
            >
              Create
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
